export default {
  label: {
    title: 'Create component',
    data: {
      title: 'Date',
    },
    details: {
      title: 'Details',
      titleInput: 'Title',
      descriptionInput: 'Description',
    },
    sensitiveData: {
      label: 'Sensitive Data (LGPD)',
    },
    viewControl: {
      title: 'View Control',
      featureFlag: 'Feature Flag',
    },
    button: {
      apply: 'Apply',
      cancel: 'Cancel',
      clearAll: 'Clear All',
    },
  },
  errorMessage: {
    default: 'Required field.',
    invalidValues: 'Invalid values.',
    details: {
      title: 'The title must be at most 50 characters.',
      description: 'The description must be at most 200 characters.',
    },
  },
  message: {
    createComponent: 'Component created successfully.',
  },
};

